import { Link } from 'react-router-dom';
import { flashItems } from '@/mocks/flash';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20abstract%20esports%20arena%20stadium%20with%20deep%20navy%20blue%20lighting%20and%20glowing%20orange%20stage%20beams%2C%20large%20digital%20screens%2C%20blurred%20crowd%20silhouettes%2C%20cinematic%20dramatic%20atmosphere%2C%20high%20detail%20editorial%20photography&width=1600&height=900&seq=home-hero-bg&orientation=landscape"
        alt="51每日大赛 赛事现场氛围背景图"
        title="51每日大赛 今日黑榜 赛事资讯"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-950/55 to-primary-950/80"></div>

      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center text-center px-4">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/95 text-primary-950 text-xs md:text-sm font-bold whitespace-nowrap">
          <span className="w-2 h-2 rounded-full bg-primary-950 animate-pulse"></span>
          今日黑榜已更新 · 实时同步
        </span>
        <h1 className="mt-5 text-3xl md:text-5xl font-black text-background-50 tracking-tight max-w-4xl leading-tight">
          51每日大赛 今日黑榜
          <span className="block text-accent-400 mt-2 text-2xl md:text-4xl">
            实时更新时间及赛事资讯
          </span>
        </h1>
        <p className="mt-5 max-w-2xl text-sm md:text-base text-background-200 leading-relaxed">
          汇聚每日大赛今日黑榜、选手排名与表现数据，覆盖星轨联赛、极光杯、雷霆竞技场等热门赛事，助你第一时间掌握比赛动态与排名变化趋势。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/blacklist"
            className="px-6 py-3 rounded-md bg-accent-500 text-primary-950 text-sm font-bold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看今日黑榜
          </Link>
          <Link
            to="/category/news"
            className="px-6 py-3 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap backdrop-blur"
          >
            浏览赛事资讯
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 inset-x-0 z-10 bg-primary-950/85 backdrop-blur border-t border-background-50/10">
        <div className="w-full px-4 md:px-8 py-3 flex items-center gap-4 overflow-hidden">
          <span className="flex items-center gap-1.5 text-accent-400 text-xs font-bold shrink-0 whitespace-nowrap">
            <i className="ri-flashlight-fill"></i>
            赛事快讯
          </span>
          <div className="flex items-center gap-6 overflow-x-auto whitespace-nowrap">
            {flashItems.map((flash) => (
              <span key={flash.id} className="text-xs md:text-sm text-background-200">
                <span className="text-foreground-400 mr-1.5">{flash.time}</span>
                {flash.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}